// src/lang/index.js
import de from "./translations/de";
import en from "./translations/en";
import fr from "./translations/fr";
import ja from "./translations/ja";
import cn from "./translations/cn";
import pl from "./translations/pl";
export default {
  en,
  de,
  fr,
  ja,
  cn,
  pl,
};
